import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import { IpValidator } from './ip.validator';

export const MultipleIpsValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    // check if value has at least one IP
    const ips = value.split(';');
    if (!ips.length) {
      return { valid: false, error: errorMessage };
    }

    // check for unique values
    const uniqueValues = ips.filter(function (ip, index) {
      return ips.indexOf(ip) === index;
    });
    if (uniqueValues.length !== ips.length) {
      return { valid: false, error: errorMessage };
    }

    // check for valid IPs
    for (const ip of ips) {
      const ipValidationResult: ValidationResult = await IpValidator(errorMessage, true, false)(ip);
      if (!ipValidationResult.valid) {
        return ipValidationResult;
      }
    }

    return { valid: true };
  };
};
